<template>
  <div>
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: right">
        <el-button type="primary" @click="addOrUpdateHandle()">新增</el-button>
      </el-form-item>
      <el-form-item style="float: right">
        <el-button @click="currentChangeHandle(1)">刷新</el-button>
      </el-form-item>
    </el-form>

    <el-table
        :data="dataList"
        border
        stripe
        v-loading="dataListLoading"
        @selection-change="selectionChangeHandle"
        style="width: 100%"
    >
      <el-table-column
          fixed
          type="index"
          align="center"
          label="序号"
          width="60"
          :index="getRowsIndex"
      >
      </el-table-column>
      <el-table-column
              fixed
              header-align="center"
              align="center"
              width="80"
              label="操作"
      >
        <template slot-scope="scope">
          <el-button
                  type="text"
                  size="small"
                  @click="deleteHandle(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="code"
          header-align="left"
          align="left"
          label="表单编号"
      >
      </el-table-column>
      <el-table-column
          prop="title"
          header-align="left"
          align="left"
          label="表单名称"
      >
      </el-table-column>
      <el-table-column
          prop="hasAttach"
          header-align="center"
          align="center"
          label="是否支持附件"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.hasAttach == true" size="small" type="small">是</el-tag>
          <el-tag v-else size="small" type="danger">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="createTime"
          header-align="center"
          align="center"
          width="180"
          label="创建时间"
      >
      </el-table-column>

    </el-table>
    <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalCount"
        layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
    <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./list_config_add_ship";

export default {
  props: {
    formId: {
      type: String,
      required: true,
    },
  },
  components: {
    AddOrUpdate,
  },
  data() {
    return {
      dataForm: {
        searchKey: "",
        formId: "",
      },
      datasourceTypeList: [],
      dictCateList: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      dataList: [],
      groupList: [],
      trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      itemListBatchsettingVisible: false,
      importFieldListVisible: false,
    };
  },
  mounted() {
    this.dataForm.formId = this.formId;
    this.getDataList();
  },
  methods: {
    getRowsIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(this.formId,id);
      });
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http
          .post("/customform/list", {
            page: this.pageIndex,
            rows: this.pageSize,
            searchKey: this.dataForm.searchKey,
            filter: {
              parentId: this.formId
            },
          },{baseURL: process.env.VUE_APP_proxybaseurl + ''})
          .then(({data}) => {
            if (data) {
              this.dataList = data.rows;
              this.totalPage = data.totalItemCount;
            } else {
              this.dataList = [];
              this.totalPage = 0;
            }
            this.dataListLoading = false;
          });
    },
    // 删除
    deleteHandle(id) {
      this.$confirm(`确定要删除该数据?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.$httpReq({
              url: "/customform/deleteCustomFromDetailShip?formId="+id,
              method: "Get",
              baseURL:  process.env.VUE_APP_proxybaseurl + ''
            }).then(({ data }) => {
              if (data && data.code === "1") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 1500,
                  onClose: () => {
                    this.getDataList();
                  },
                });
              } else {
                this.$message.error(data.msg);
              }
            });
          })
          .catch(() => {});
    },
  },
};
</script>
